/* Brindes automáticos no carrinho, em dois formatos:
     - por valor de compra (níveis, window.LofRewards.brindes);
     - por produto comprado ("compre X, ganhe Y", window.LofRewards.combos).

   Os dois compartilham a mesma máquina: planejar → executar → conferir. A única
   diferença está em elegivel().

   Cada oferta precisa do seu desconto no Shopify, com "combina com descontos de
   produto" ligado: o tema só coloca o produto no carrinho, quem zera é o
   Shopify. E como o Shopify aplica UM desconto automático de produto por pedido,
   vale uma oferta por vez — o combo tem prioridade (ver R.niveisAtivos). */
(function () {
  'use strict';

  var R = window.LofRewards;
  if (!R) return;

  /* Todas as ofertas configuradas. Quais valem AGORA depende do carrinho —
     ver elegivel(). */
  var TODAS = R.brindes.concat(R.combos);
  if (!TODAS.length) return;

  var SELO = R.textos.selo || 'BRINDE';
  var TXT_ADD = R.textos.adicionar || 'Adicionar meu brinde';
  var TXT_COMBO = '🎁 {produto} grátis no carrinho!';

  function ehCombo(o) { return !!o.gatilhos; }

  function chave(p, o) { return 'lof-brinde-' + p + '-' + o.id; }
  function flag(k) { try { return sessionStorage.getItem(k) === '1'; } catch (e) { return false; } }
  function marcar(k, v) { try { v ? sessionStorage.setItem(k, '1') : sessionStorage.removeItem(k); } catch (e) {} }

  var ocupado = false;

  function pedir(url, corpo) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(corpo)
    }).then(function (r) {
      if (!r.ok) throw new Error(url + ' ' + r.status);
      return r.json();
    });
  }

  function adicionar(o) {
    return pedir('/cart/add.js', {
      id: o.variante,
      quantity: 1,
      properties: { _brinde: ehCombo(o) ? o.id : String(o.nivel) }
    });
  }

  function remover(k) { return pedir('/cart/change.js', { id: k, quantity: 0 }); }

  function linhasBrinde(c) { return c.items.filter(R.ehBrinde); }

  function ofertaDaLinha(l) {
    for (var i = 0; i < TODAS.length; i++) {
      if (String(TODAS[i].variante) === String(l.variant_id)) return TODAS[i];
    }
    return null;
  }

  /* Combo: o carrinho tem um dos produtos do gatilho, e ele é o combo da vez.
     Nível: o carrinho atingiu o valor mínimo E nenhum combo está ativo — o
     Shopify aplica um desconto automático de produto por pedido, então os dois
     juntos se anulariam (quem sobra é o combo). */
  function elegivel(o, c) {
    if (ehCombo(o)) {
      return R.combosAtivos(c).some(function (a) { return a.id === o.id; });
    }
    return R.niveisAtivos(c).length > 0 && R.valorBase(c) >= o.valor;
  }

  /* Monta a lista de alterações num passo só, para executar em série e
     re-renderizar uma vez — e não uma vez por oferta. */
  function planejar(c) {
    var linhas = linhasBrinde(c);

    var querendo = TODAS.filter(function (o) {
      return elegivel(o, c) &&
             !flag(chave('sem-desconto', o)) &&
             !flag(chave('recusado', o));
    });

    var plano = [];

    linhas.forEach(function (l) {
      var o = ofertaDaLinha(l);
      /* Linha órfã: produto saiu da campanha desde que entrou no carrinho. */
      var manter = o && querendo.some(function (q) { return q.id === o.id; });

      /* Combo cujo produto o cliente passou a comprar: a linha de brinde sai,
         para não sobrar unidade repetida disputando o mesmo desconto. Limpamos
         a marcação de "já adicionado" para o brinde poder voltar se ele
         desistir da compra paga. */
      if (manter && ehCombo(o) && R.temPago(c, o.variante)) {
        manter = false;
        marcar(chave('adicionado', o), false);
      }

      if (!manter) plano.push({ tipo: 'remover', chave: l.key });
    });

    querendo.forEach(function (o) {
      /* Combo: se o cliente já está comprando o produto do brinde, não
         acrescentamos uma segunda linha — o desconto do Shopify zera a unidade
         que ele já tem, e o benefício sai igual sem risco de cobrar duas. */
      if (ehCombo(o) && R.temPago(c, o.variante)) return;

      var tem = linhas.some(function (l) { return String(l.variant_id) === String(o.variante); });
      if (tem) return;
      /* Já foi adicionado antes e some agora: o cliente tirou de propósito. */
      if (flag(chave('adicionado', o))) {
        marcar(chave('recusado', o), true);
        return;
      }
      plano.push({ tipo: 'adicionar', oferta: o });
    });

    return plano;
  }

  /* Oferta que deixou de valer (valor caiu, gatilho saiu do carrinho) volta à
     estaca zero: se as condições se repetirem, o brinde é oferecido de novo. */
  function limparBloqueadas(c) {
    TODAS.forEach(function (o) {
      if (elegivel(o, c)) return;
      marcar(chave('recusado', o), false);
      marcar(chave('adicionado', o), false);
    });
  }

  function executar(plano) {
    return plano.reduce(function (fila, acao) {
      return fila.then(function () {
        if (acao.tipo === 'remover') return remover(acao.chave);
        return adicionar(acao.oferta).then(function () {
          marcar(chave('adicionado', acao.oferta), true);
        });
      });
    }, Promise.resolve());
  }

  /* Rede de segurança: se o desconto do Shopify não existir, tiver expirado,
     estiver com valor diferente ou não combinar com os outros, o brinde entra
     cobrando. Nesse caso desfazemos e desligamos aquela oferta nesta visita. */
  function conferir() {
    return R.carrinho().then(function (c) {
      var cobrando = linhasBrinde(c).filter(function (l) { return l.final_line_price > 0; });
      if (!cobrando.length) return null;

      return cobrando.reduce(function (fila, l) {
        return fila.then(function () {
          var o = ofertaDaLinha(l);
          if (o) marcar(chave('sem-desconto', o), true);
          console.warn('[LOF] Brinde removido (' + l.title + '): o desconto do Shopify não zerou o item. ' +
                       'Confira se existe um desconto ativo para esta oferta, com a mesma condição ' +
                       'e com "combina com descontos de produto" ligado.');
          return remover(l.key);
        });
      }, Promise.resolve());
    });
  }

  function pintar(c) {
    var pendentes = TODAS.filter(function (o) {
      return elegivel(o, c) &&
             flag(chave('recusado', o)) &&
             !flag(chave('sem-desconto', o));
    });

    document.querySelectorAll('[data-gift-cta]').forEach(function (el) {
      el.innerHTML = (pendentes.length && c.items.length)
        ? '<button type="button" data-gift-add class="lof-gift__add">' + TXT_ADD + '</button>'
        : '';
    });

    /* Combos não são marcos da barra (não dependem de valor), então avisam em
       linha própria que o brinde está garantido. */
    var ativos = c.items.length ? R.combosAtivos(c).filter(function (o) {
      /* Só anuncia o que está de fato no carrinho: se o cliente recusou o
         brinde, quem fala é o botão de readicionar, não este aviso. */
      return R.temPago(c, o.variante) ||
             linhasBrinde(c).some(function (l) { return String(l.variant_id) === String(o.variante); });
    }) : [];
    var aviso = ativos.map(function (o) {
      return (o.msg || TXT_COMBO).replace(/\{produto\}/g, o.rotulo);
    }).join(' ');

    document.querySelectorAll('[data-combo-msg]').forEach(function (el) {
      el.textContent = aviso;
      /* Sem nenhum marco configurado a barra fica escondida; o aviso do combo
         precisa aparecer de todo jeito. */
      var bloco = el.closest('.lof-prog');
      if (bloco && aviso) bloco.classList.add('is-ready');
    });

    /* Selo por linha. O theme.js reescreve a lista por innerHTML, então
       reinjetamos a cada atualização. */
    linhasBrinde(c).forEach(function (l) {
      /* querySelectorAll porque na página /cart a linha aparece duas vezes: no
         HTML do servidor e no drawer. */
      document.querySelectorAll('[data-line-key="' + l.key + '"]').forEach(function (el) {
        if (el.querySelector('[data-gift-badge]')) return;
        var badge = document.createElement('span');
        badge.setAttribute('data-gift-badge', '');
        badge.className = 'lof-gift__badge';
        badge.textContent = SELO;
        var titulo = el.querySelector('p');
        if (titulo) titulo.insertAdjacentElement('afterend', badge);
      });
    });
  }

  function sincronizar() {
    if (ocupado) return;
    ocupado = true;

    R.carrinho()
      .then(function (c) {
        limparBloqueadas(c);
        var plano = planejar(c);
        if (!plano.length) { pintar(c); return null; }
        return executar(plano).then(conferir).then(R.rerenderizar);
      })
      .catch(function () {})
      .finally(function () { ocupado = false; });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-gift-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    btn.disabled = true;
    TODAS.forEach(function (o) {
      marcar(chave('recusado', o), false);
      marcar(chave('adicionado', o), false);
    });
    sincronizar();
  });

  var drawer = document.querySelector('[data-cart-drawer]');
  var subtotal = drawer && drawer.querySelector('[data-cart-subtotal]');
  var itens = drawer && drawer.querySelector('[data-cart-items]');
  if (window.MutationObserver) {
    if (subtotal) new MutationObserver(sincronizar).observe(subtotal, { childList: true, characterData: true, subtree: true });
    if (itens) new MutationObserver(sincronizar).observe(itens, { childList: true });
  }
  sincronizar();
})();
